import { Text, UseDisclosureReturn } from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useMutationUpdateUser } from "../../../../store/useMutationUpdateUser";
import { InputField } from "../../../forms/InputField";
import { FormModal } from "../../../modals/FormModal";

type EditDisplayNameFormValues = {
  name: string;
};

export function EditDisplayNameModal({
  currentFullName,
  disclosure,
}: {
  currentFullName: string;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const values = React.useMemo<EditDisplayNameFormValues>(
    () => ({
      name: currentFullName,
    }),
    [currentFullName],
  );

  const form = useForm<EditDisplayNameFormValues>({
    values,
    mode: "onTouched",
    resetOptions: {
      keepDirtyValues: true,
    },
  });

  const mutationUpdateUser = useMutationUpdateUser();

  const onSubmit = async (data: EditDisplayNameFormValues) => {
    await mutationUpdateUser.mutateAsync({
      fullName: data.name,
    });
  };

  return (
    <FormModal
      disclosure={disclosure}
      form={form}
      title={`${currentFullName ? "Edit" : "Add"} display name`}
      submitButtonText="Save changes"
      submitCondition="dirty"
      successTitle="Display name updated"
      errorTitle="Update failed"
      onSubmit={onSubmit}
    >
      <Text color="gray.600" mb={6}>
        Set your display name. People you share account access with can see
        this.
      </Text>

      <InputField
        form={form}
        name="name"
        label="Display name"
        placeholder="Satoshi Nakamoto"
        type="text"
        autoFocus
      />
    </FormModal>
  );
}
